/* tslint:disable */
/* eslint-disable */
/**
 * grpc/v1/close_reasons_service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { CloseReasonsServiceUpdateCloseReasonBody } from '../models'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { V1CreateCloseReasonRequest } from '../models'
// @ts-ignore
import { V1CreateCloseReasonResponse } from '../models'
// @ts-ignore
import { V1ListCloseReasonsResponse } from '../models'
// @ts-ignore
import { V1UpdateCloseReasonResponse } from '../models'
/**
 * CloseReasonsServiceApi - axios parameter creator
 * @export
 */
export const CloseReasonsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {V1CreateCloseReasonRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    closeReasonsServiceCreateCloseReason: async (
      body: V1CreateCloseReasonRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('closeReasonsServiceCreateCloseReason', 'body', body)
      const localVarPath = `/api/v1/deals/references/close-reasons`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    closeReasonsServiceDeleteCloseReason: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('closeReasonsServiceDeleteCloseReason', 'id', id)
      const localVarPath = `/api/v1/deals/references/close-reasons/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {boolean} [includeInactive]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    closeReasonsServiceListCloseReasons: async (
      includeInactive?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/deals/references/close-reasons`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (includeInactive !== undefined) {
        localVarQueryParameter['includeInactive'] = includeInactive
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {CloseReasonsServiceUpdateCloseReasonBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    closeReasonsServiceUpdateCloseReason: async (
      id: string,
      body: CloseReasonsServiceUpdateCloseReasonBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('closeReasonsServiceUpdateCloseReason', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('closeReasonsServiceUpdateCloseReason', 'body', body)
      const localVarPath = `/api/v1/deals/references/close-reasons/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CloseReasonsServiceApi - functional programming interface
 * @export
 */
export const CloseReasonsServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CloseReasonsServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {V1CreateCloseReasonRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async closeReasonsServiceCreateCloseReason(
      body: V1CreateCloseReasonRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateCloseReasonResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.closeReasonsServiceCreateCloseReason(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CloseReasonsServiceApi.closeReasonsServiceCreateCloseReason']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async closeReasonsServiceDeleteCloseReason(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.closeReasonsServiceDeleteCloseReason(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CloseReasonsServiceApi.closeReasonsServiceDeleteCloseReason']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {boolean} [includeInactive]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async closeReasonsServiceListCloseReasons(
      includeInactive?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListCloseReasonsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.closeReasonsServiceListCloseReasons(
        includeInactive,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CloseReasonsServiceApi.closeReasonsServiceListCloseReasons']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {CloseReasonsServiceUpdateCloseReasonBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async closeReasonsServiceUpdateCloseReason(
      id: string,
      body: CloseReasonsServiceUpdateCloseReasonBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateCloseReasonResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.closeReasonsServiceUpdateCloseReason(id, body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CloseReasonsServiceApi.closeReasonsServiceUpdateCloseReason']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * CloseReasonsServiceApi - factory interface
 * @export
 */
export const CloseReasonsServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = CloseReasonsServiceApiFp(configuration)
  return {
    /**
     *
     * @param {V1CreateCloseReasonRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    closeReasonsServiceCreateCloseReason(
      body: V1CreateCloseReasonRequest,
      options?: any,
    ): AxiosPromise<V1CreateCloseReasonResponse> {
      return localVarFp
        .closeReasonsServiceCreateCloseReason(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    closeReasonsServiceDeleteCloseReason(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .closeReasonsServiceDeleteCloseReason(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {boolean} [includeInactive]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    closeReasonsServiceListCloseReasons(
      includeInactive?: boolean,
      options?: any,
    ): AxiosPromise<V1ListCloseReasonsResponse> {
      return localVarFp
        .closeReasonsServiceListCloseReasons(includeInactive, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {CloseReasonsServiceUpdateCloseReasonBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    closeReasonsServiceUpdateCloseReason(
      id: string,
      body: CloseReasonsServiceUpdateCloseReasonBody,
      options?: any,
    ): AxiosPromise<V1UpdateCloseReasonResponse> {
      return localVarFp
        .closeReasonsServiceUpdateCloseReason(id, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * CloseReasonsServiceApi - object-oriented interface
 * @export
 * @class CloseReasonsServiceApi
 * @extends {BaseAPI}
 */
export class CloseReasonsServiceApi extends BaseAPI {
  /**
   *
   * @param {V1CreateCloseReasonRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CloseReasonsServiceApi
   */
  public closeReasonsServiceCreateCloseReason(
    body: V1CreateCloseReasonRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CloseReasonsServiceApiFp(this.configuration)
      .closeReasonsServiceCreateCloseReason(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CloseReasonsServiceApi
   */
  public closeReasonsServiceDeleteCloseReason(id: string, options?: RawAxiosRequestConfig) {
    return CloseReasonsServiceApiFp(this.configuration)
      .closeReasonsServiceDeleteCloseReason(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {boolean} [includeInactive]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CloseReasonsServiceApi
   */
  public closeReasonsServiceListCloseReasons(
    includeInactive?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return CloseReasonsServiceApiFp(this.configuration)
      .closeReasonsServiceListCloseReasons(includeInactive, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {CloseReasonsServiceUpdateCloseReasonBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CloseReasonsServiceApi
   */
  public closeReasonsServiceUpdateCloseReason(
    id: string,
    body: CloseReasonsServiceUpdateCloseReasonBody,
    options?: RawAxiosRequestConfig,
  ) {
    return CloseReasonsServiceApiFp(this.configuration)
      .closeReasonsServiceUpdateCloseReason(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
